import { memo } from 'react'

const PatientsListSkeleton = () => {
  return (
    <>
      <style>{`
        .skeleton-container {
          margin-top: 10%;
          padding: 1.5rem 150px;
          background-color: #fff;
        }

        .skeleton-header {
          display: flex;
          gap: 2rem;
          align-items: center;
          margin-bottom: 2rem;
          animation: pulse 2s infinite;
        }

        .header-bar {
          height: 1rem;
          background-color: #E8E8E8;
          border-radius: 0.2rem;
        }

        .skeleton-row {
          display: flex;
          gap: 2rem;
          background-color: #E8E8E8;
          border-radius: 1.5rem;
          padding: 1rem;
          box-shadow: 0 1px 3px rgba(0,0,0,0.1);
          margin-bottom: 3rem;
          animation: pulse 2s infinite;
        }

        .skeleton-bar {
          height: 2rem;
          width: 85%;
          background-color: #E8E8E8;
          border-radius: 1.5rem;
          position: relative;
        }

        .skeleton-sub-bar {
          position: absolute;
          top: 50%;
          left: 10%;
          transform: translateY(-50%);
          height: 1rem;
          background-color: #d0d0d0;
          border-radius: 0.1rem;
        }

        .top-divider {
          height: 1px;
          background-color: #ccc;
          margin-bottom: 1.5rem;
        }

        @keyframes pulse {
          0%, 80% {
            opacity: 1;
          }
          20% {
            opacity: 0.4;
          }
        }
      `}</style>

      <div className="skeleton-container">

        <div className="skeleton-header">
            <div className="header-bar" style={{ width: '5%' }} />
            <div className="header-bar" style={{ width: '10%' }} />

        </div>

        <div className="top-divider" />

        <div className="skeleton-header">
          <div className="header-bar" style={{ width: '15%' }} />
          <div className="header-bar" style={{ width: '3%' }} />
          <div className="header-bar" style={{ width: '6%' }} />
          <div className="header-bar" style={{ width: '15%' }} />
        </div>

        

        {[...Array(5)].map((_, i) => (
          <div key={i}>
            <div
              className="skeleton-row"
              style={{ animationDelay: `${i * 0.2}s` }}
            >
              {[60, 60, 20, 40, 60, 15].map((width, j) => (
                <div key={j} className="skeleton-bar">
                  <div
                    className="skeleton-sub-bar"
                    style={{ width: `${width}%` }}
                  />
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </>
  )
}

export default memo(PatientsListSkeleton)
